import React, { Component } from 'react';
import { Col, Row, Alert, Button, ButtonGroup } from 'react-bootstrap/lib';
import { LoadingScreen } from '../generic/input';
import { VehMultiDropDown } from './inputs/vehMultiSelect';
import { GetSalesPanelCount } from '../services/apiFunnel';
import { formatCurrency, isVehValid, _setNewUrl, getDevices, getVidArray } from '../lib/common';
import TabularFormat from './tabularFormat';
import { GetTriggersData } from '../db/triggers';
import { GetVehicleStatus, GetJourney } from '../lib/db/journeys';
import MapDisplay from './mapDisplay';
import { Object } from 'core-js';
import { jsonToCSVConvertor } from '../lib/jsonUtils';
import { StampTODate, timeFormat } from '../lib/dtconv';
const { VEH_SHIP_STATS, MENUPATH } = require('../lib/enums');
const TRIGGER_TYP = 2;

export default class DashBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gfData: "",
      errMsg: "",
      list: false,
      vehicles: [],
      isLoading: true,
      filt: "",
      subId: "",
    }
    this.selectedVehs = [];
    this.lastSeenData = {};
    this.validVeh = null;
    this.selectedIds = [];
    this.vehicleStatus = {};
    this.deviceVehHashMap = {};
    this.journeys = {};
    this.vehInShipment = {};
    this.showFiltData = {};
    this.filterBikeDetailsToShow = {};
    this.pingData = {};
  }

  componentWillMount() {
    global.EE.addEventListener(global.EE.EVENT_TYPES.BIKES, this.onBikes);
    global.EE.addEventListener(global.EE.EVENT_TYPES.ON_CHANGE_VEHSTAT, this.onChangeVehicleStat);
    global.EE.addEventListener(global.EE.EVENT_TYPES.SUB_VEH, this.onVehSub);
  }

  componentDidMount() {
    if (global.wsOnline) {
      if (global.bikeDetails) this.onBikes(global.bikeDetails);
    }
    global.EE.emitEvent(global.EE.EVENT_TYPES.MENU_CHANGE, MENUPATH.DASHBOARD);

    if (window.localStorage.getItem("usrTyp") === "3") { // Dealer
      GetSalesPanelCount()
        .then((countObj) => this.setState({ countObj }))
        .catch((e) => this.setState({ err: e }));
    }
    if (this.props.location.query && this.props.location.query.filt) {
      this.setState({
        filt: parseInt(this.props.location.query.filt),
        subId: parseInt(this.props.location.query.subId)
      })
    }
    // GetJourney((err, journeys) => { // TODO: changes compatible with indexedDB
    //   if (err) {
    //     this.setState({
    //       infoMsg: err
    //     });
    //     return;
    //   }
    //   if (journeys && journeys.length) {
    //     journeys.forEach(d => {
    //       this.journeys[d.idx] = d.nm;
    //     });
    //     this.forceUpdate();
    //   }
    // });
  }

  componentWillUnmount() {
    global.EE.removeEventListener(global.EE.EVENT_TYPES.BIKES, this.onBikes);
    global.EE.removeEventListener(global.EE.EVENT_TYPES.ON_CHANGE_VEHSTAT, this.onChangeVehicleStat);
    global.EE.removeEventListener(global.EE.EVENT_TYPES.SUB_VEH, this.onVehSub);
  }

  onChangeVehicleStat = (data) => {
    var sendStatus = 1;
    var status = this.vehicleStatus[data.vid];
    if (status) sendStatus = status;
    if (this._filter) this._filter.onChangeVehicleStatus(data, sendStatus)
    this.vehicleStatus[data.vid] = data.stat;
    if (data.stat === VEH_SHIP_STATS.ENROUTE_DEST || data.stat === VEH_SHIP_STATS.AT_DEST || data.stat === VEH_SHIP_STATS.ENROUTE_SRC)
      this.vehInShipment[data.vid] = data.journeyId;
    if (data.stat === VEH_SHIP_STATS.AT_SRC_END) {
      var shipmentExist = this.vehInShipment[data.vid];
      if (shipmentExist) delete this.vehInShipment[data.vid];
    }
    this.forceUpdate();
  }

  GetVehicleStatus = (vehIdArr) => {
    GetVehicleStatus(vehIdArr, (err, vehicleStatus) => {
      if (err) {
        this.setState({
          infoMsg: err
        });
        return;
      }
      if (vehicleStatus) {
        var vehStatus = Object.keys(vehicleStatus);
        if (vehStatus.length > 0) {
          vehStatus.forEach(d => {
            this.vehicleStatus[parseInt(d)] = vehicleStatus[d]["stat"];
            var status = vehicleStatus[d]["stat"];
            if (status && (status === VEH_SHIP_STATS.ENROUTE_DEST || status === VEH_SHIP_STATS.AT_DEST || status === VEH_SHIP_STATS.ENROUTE_SRC))
              this.vehInShipment[parseInt(d)] = vehicleStatus[d]["journeyId"];
          });
          this.forceUpdate();
        }
        this.sendTitleToFilters(vehStatus.length);
      }
      else this.sendTitleToFilters(0);
    });
  }

  onBikes = (bikes) => {
    if (bikes && bikes.length) {
      this.vehicles = bikes;
      var devices = getDevices(bikes);
      if (devices.length) {
        var vehIdArr = [];
        bikes.forEach((bike, i) => {
          if (bike.did) {
            vehIdArr.push(bike.idx);
            this.deviceVehHashMap[bike.did] = bike.idx;
          }
        });
        // this.GetVehicleStatus(vehIdArr);  //TODO: changes compatible with indexedDB
        if (this.props.location && this.props.location.query && this.props.location.query.vid) {
          this.selectedIds = getVidArray(this.props.location.query.vid);
          if (this.selectedIds && this.selectedIds.length) this.validVeh = isVehValid(bikes, this.selectedIds);
          if (this.validVeh) {
            var selVehs = bikes.filter(v => {
              return this.selectedIds.indexOf(v.idx) > -1
            });
            this.onVehicleSelect(selVehs);
          }
        } else this.onVehicleSelect(bikes);
      } else {
        this.didnotpresent = true;
        this.setState({
          errMsg: "Please install ajjas device",
          isLoading: false
        });
      }
    } else {
      this.setState({
        errMsg: "",
        isLoading: false
      });
    }
  }

  onVehSub = (data) => { //realtime data
    if (data && data.obj && (data.obj.lat || data.obj.lng)) {
      this.lastSeenData[data.obj.vid] = data.obj;
      if (this.pingData && this.pingData[data.obj.vid]) delete this.pingData[data.obj.vid];
    }
    else if (data && data.obj && data.obj.vid) this.pingData[data.obj.vid] = data.obj;
    if (this.selectedFiltDid && this.selectedFiltDid.length) {
      var sendData = this.selectedFiltDid.find(d => d === data.obj.vid);
      if (sendData) {
        if (this.state.list && this._tabularFormatRef) this._tabularFormatRef.acceptLastSeen(this.lastSeenData);
        else if (this._mapRef) this._mapRef.acceptLastSeen(this.lastSeenData);
      }
    }
    else {
      if (this.state.list && this._tabularFormatRef) this._tabularFormatRef.acceptLastSeen(this.lastSeenData);
      else if (this._mapRef) this._mapRef.acceptLastSeen(this.lastSeenData);
    }
  }

  showGeoFence(selectedVehs) {
    GetTriggersData(TRIGGER_TYP, (err, gfData) => {
      if (err) {
        this.setState({
          infoMsg: err
        });
        return;
      }
      if (gfData && gfData.length) {
        gfData = gfData.filter(d => !d.src) //seperate shipment Geofence from original Geofence
        var newGfData = [], vids = [];
        if (selectedVehs && selectedVehs.length) {
          selectedVehs.forEach(veh => {
            vids.push(veh.idx);
          });
        }
        gfData.forEach(d => {
          this._checkGfVidsAreSelected(d.vehIdArr, vids, () => {
            newGfData.push(d);
          });
        });

        this.setState({ gfData: newGfData })
      }
    });
  }

  _checkGfVidsAreSelected(gfvids, vids, cb) {
    gfvids.forEach((v) => {
      if (vids.indexOf(v) > -1) cb();
    });
  }

  getLastSeen = (vids) => {
    var reqLsVids = [];
    if (!this.state.list && this._mapRef) this._mapRef.changeMapstate();
    if (vids.length) {
      if (this.vehicles) {
        var data = { a: "getDynamicLastSeen" };
        if (vids) {
          if (this.lastSeenData && Object.keys(this.lastSeenData).length) {
            vids.forEach(id => {
              if (Object.keys(this.lastSeenData).indexOf(id.toString()) < 0) reqLsVids.push(id);
            });
            if (reqLsVids && reqLsVids.length) {
              data.d = { vids: reqLsVids };
            }
            else {
              this.sendTitleToFilters(0);
              if (!this.state.list && this._mapRef)
                this._mapRef.acceptLastSeen(this.lastSeenData);
              return;
            }
          } else data.d = { vids: vids };
        }
        global.gWebSocket.SendRequest({
          data: data,
          cb: (resp) => {
            if (resp && resp.d && resp.d.length) {
              resp.d.forEach((ls, i) => {
                if (ls && Object.keys(ls).length) this.lastSeenData[ls.vid] = ls;
                if (i === (resp.d.length - 1)) {
                  this.sendTitleToFilters(0);
                  this.setState({
                    errMsg: ""
                  });
                  if (!this.state.list && this._mapRef) {
                    this._mapRef.acceptLastSeen(this.lastSeenData);
                  }
                }
              });
            }
            else {
              var err = true;
              this.selectedVehs.forEach((veh) => {
                if (Object.keys(this.lastSeenData).indexOf(veh.idx.toString()) > -1) err = false;
              });
              if (err) {
                this.setState({
                  errMsg: "No location data available for this vehicle yet. Vehicle will be visible on map when there is a location update. Please select another vehicle/contact service executive."
                });
              }
            }
            this.setState({ isLoading: false })
          }
        });
        this.subscibeVehs(vids);
      }
    } else {
      this.setState({
        isLoading: false,
        errMsg: "Map an ajjas device to track these vehicles"
      });
    }
  }

  sendTitleToFilters(vehStatusLength) {
    if (this._filter && (Object.keys(this.vehicleStatus).length || vehStatusLength === 0) && Object.keys(this.lastSeenData).length) {
      this._filter.getTitleForFilter(this.lastSeenData);
    }
  }

  subscibeVehs(vids) {
    // var subVehs = [];
    // var toBeSubVehs = [];
    // if (vids && vids.length && global.subVeh && global.subVeh.length) subVehs = global.subVeh.filter(vid => vids.includes(vid));
    // toBeSubVehs = vids.filter(vids => subVehs.indexOf(vids) < 0);

    if (vids && vids.length) {
      var data = { a: "subVeh", d: { veh: vids} };
      // if (global.subVeh && global.subVeh.length) global.subVeh.concat(vids);
      global.gWebSocket.SendRequest({ data: data });
      if (this._mapRef) if (this._mapRef) this._mapRef.onVehSubUnSub(vids, true);
    }

  }

  unSubscribe(vids) {
    if (this.selectedVehs.length && vids.length) {
      vids.forEach(v => {
        var index = global.subVeh.findIndex(sub => { return sub === v });
        if (index !== -1) global.subVeh.splice(index, 1)
      });
      var data = { a: "unsubVeh", d: { veh: vids } };
      global.gWebSocket.SendRequest({
        data: data
      });
      vids.forEach((v) => {
        delete this.lastSeenData[v];
      });
      if (this._mapRef) this._mapRef.onVehSubUnSub(vids, false);
    }
  }

  findIndexInData(data, key, value) {  //find the index of value in array of objects specifying key name
    for (var i = 0, l = data.length; i < l; i++) {
      if (data[i][key] === value) return i;
    }
    return -1;
  }

  onVehicleSelect(selectedVeh) {
    this.showFiltData = {};
    this.filterBikeDetailsToShow = {};
    var subVeh = [], unsubVeh = [];
    this.selectedVehs = selectedVeh;
    this.vehicles.forEach(veh => {
      if (this.findIndexInData(selectedVeh, 'idx', veh.idx) < 0) {
        unsubVeh.push(veh.idx);
      }
    });

    if (selectedVeh && selectedVeh.length) {
      selectedVeh.forEach(veh => {
        subVeh.push(veh.idx);
      });
    }
    this.showGeoFence(selectedVeh);
    this.forceUpdate(() => {
      if (subVeh) { this.getLastSeen(subVeh); }
      if (unsubVeh && unsubVeh.length) this.unSubscribe(unsubVeh);
    });
  }

  OnToggleMap(id) {
    //remain to check that if list toggle to map
    this.setState({ list: id === 1 ? false : true })
  }

  onClickApplyButton = (selectedIds) => {
    var vids = [], selIds = [];
    selectedIds.forEach(veh => {
      if (veh && veh.checked) {
        vids.push(veh.idx);
        selIds.push(veh);
      }
    });

    if (selIds.length) {
      this.validVeh = isVehValid(this.vehicles, vids);
      var newUrl = _setNewUrl(this.props.location, vids);
      this.props.router.replace(newUrl);
      this.onVehicleSelect(selIds);
    }
    else {
      this.props.router.replace('/webapptl/dashboard');
      this.onVehicleSelect(this.vehicles);
    }
  }
  clearAll = (vehs) => {
    var loc = this.props.location
    var newUrl = loc.pathname;
    this.props.router.replace(newUrl);
    this.onVehicleSelect(this.vehicles);
  }

  changeFilter = (didArr, filt, subId) => {
    this.showFiltData = {};
    this.selectedFiltDid = didArr;
    didArr.forEach(d => {
      var lastSeen = this.lastSeenData[d];
      if (lastSeen) this.showFiltData[d] = lastSeen;

    });
    if (filt) {
      var bikes = this.selectedVehs.filter(d => { return didArr.indexOf(d.did) > -1 });
      this.filterBikeDetailsToShow = bikes;
    }
    else this.filterBikeDetailsToShow = this.selectedVehs;
    var setData = { filt: filt }
    if (subId) setData.subId = subId;
    this.setState(setData);
  }

  handleDownload = () => {
    let vehicles = this.filterBikeDetailsToShow && Object.keys(this.filterBikeDetailsToShow).length ? this.filterBikeDetailsToShow : this.selectedVehs;
    let lastSeen = this.showFiltData && Object.keys(this.showFiltData).length ? this.showFiltData : this.lastSeenData;

    var excelData = vehicles.filter(veh => veh.dev).map((data, idx) => {
      let lastSeenData = lastSeen[data.idx];
      var obj = {};
      obj["S. No."] = idx + 1;
      obj["Make"] = data.vmk || "-";
      obj["Model"] = data.mo || "-";
      obj["Registration No."] = data.reg || "-";
      obj["Chassis No."] = data.chNum || "-";
      obj["IMEI"] = data.dev && data.dev.imei ? data.dev.imei : "-";
      obj["Last Seen (Date)"] = lastSeenData && lastSeenData.ts ? `${StampTODate(lastSeenData.ts * 1000)}` : "-";
      obj["Last Seen (Time)"] = lastSeenData && lastSeenData.ts ? `${timeFormat(lastSeenData.ts * 1000)}` : "-";
      obj["Ignition"] = lastSeenData ? (lastSeen[data.idx].ignition ? "On" : "Off") : "-";
      obj["Speed (km/h)"] = lastSeenData && lastSeenData.spd ? lastSeenData.spd : "0";

      return obj;
    });

    jsonToCSVConvertor(excelData, "details" + Date.now(), true, "Last_Ping_");
  }

  render() {
    return (
      <Col>
        {this.state.isLoading ? <LoadingScreen /> : null}
        {/* Statistics View Row */}
        {
          this.state.countObj
            ? <Row>
              <Col xs={12} md={4}>
                <h2>Revenue Summary</h2>
                <Col xs={12}>
                  <h4>Total Revenue Earned: {getCount(formatCurrency(this.state.countObj.total_revenue))} </h4>
                </Col>
                <Col xs={12}>
                  <h4>Daily Average Earnings: {getCount(formatCurrency(this.state.countObj.daily_average))}</h4>
                </Col>
                <Col xs={12}>
                  <h4>Projected Yearly Earnings: {getCount(formatCurrency(this.state.countObj.projected_yearly))}</h4>
                </Col>
              </Col>
              <Col xs={12} md={4}>
                <h2>Ajjas Summary</h2>
                <Col xs={12}>
                  <h4>Total Devices Pitched: {getCount(this.state.countObj.total_pitched)}</h4>
                </Col>
                <Col xs={12}>
                  <h4>Daily Average Bookings: {getCount(this.state.countObj.daily_average_bookings)}</h4>
                </Col>
              </Col>
            </Row>
            : null
        }
        <div>
          {
            this.didnotpresent && this.state.errMsg ?
              <Alert bsStyle="warning">{this.state.errMsg}</Alert>
              :
              <div>
                {
                  this.vehicles && this.vehicles.length ?
                    <Row style={{ marginBottom: "2%" }}>
                      <Col xs={12}>
                        <ButtonGroup size="lg" >
                          <Button id={1} style={{ width: "110px", backgroundColor: (!this.state.list ? "#00a8e2" : "white") }} onClick={(e) => this.OnToggleMap(1)}><span style={{ color: (!this.state.list ? "white" : "#00a8e2") }}>Map</span></Button>
                          <Button id={2} style={{ width: "110px", backgroundColor: (!this.state.list ? "white" : "#00a8e2") }} onClick={(e) => this.OnToggleMap(2)}><span style={{ color: (!this.state.list ? "#00a8e2" : "white") }}>List</span></Button>
                        </ButtonGroup>
                      </Col>
                    </Row>
                    : null
                }
                <Row>
                  {
                    this.vehicles && this.vehicles.length > 1 ?
                      <Col lg={4} lgOffset={this.vehicles && this.vehicles.length > 1 ? 8 : 10} md={6} mdOffset={this.vehicles && this.vehicles.length > 1 ? 6 : 9} sm={6} smOffset={this.vehicles && this.vehicles.length > 1 ? 6 : 8} xs={12} style={{ marginBottom: "2%" }}>
                        <VehMultiDropDown
                          headerName="Vehicle Filter"
                          headingStyle={{ fontSize: "15px", border: "1px solid #ccc", borderRadius: "5px", width: "100%" }}
                          clearStyle={{ color: "#d6001a", fontSize: "14px" }}
                          options={this.vehicles}
                          selectedVehs={this.props.location.query && this.props.location.query.vid ? Array.isArray(this.props.location.query.vid) === true ?
                            this.props.location.query.vid : [this.props.location.query.vid] : 0}
                          onClear={(vehs) => this.clearAll(vehs)}
                          onApply={(selectedIds) => this.onClickApplyButton(selectedIds)}
                        />
                      </Col>
                      : null
                  }
                </Row>
                <Row>
                  {
                    this.state.list && this.vehicles && this.vehicles.length ? this.vehicles.length === 1 && !this.vehicles[0].did ? null :
                      <div>
                        <Button id={1} style={{ width: "110px", backgroundColor: "#00a8e2", border: "none", position: "absolute", left: "15px", top: "60px" }} onClick={this.handleDownload}><span style={{ color: "white" }}>Download</span></Button>
                        <TabularFormat
                          vehicles={this.filterBikeDetailsToShow && Object.keys(this.filterBikeDetailsToShow).length ? this.filterBikeDetailsToShow : this.selectedVehs}
                          lastSeen={this.showFiltData && Object.keys(this.showFiltData).length ? this.showFiltData : this.lastSeenData}
                          ref={tabularFormat => this._tabularFormatRef = tabularFormat}
                          vehicleStatus={this.vehicleStatus} vehInShipment={this.vehInShipment} journeys={this.journeys}
                        />
                      </div>
                      : this.state.errMsg ?
                        <Col lg={12} md={12} sm={12}><Alert bsStyle="warning">{this.state.errMsg}</Alert></Col>
                        :
                        this.vehicles && this.vehicles.length &&
                          ((this.showFiltData && Object.keys(this.showFiltData).length) || (this.lastSeenData && Object.keys(this.lastSeenData).length)) ?
                          <MapDisplay selectedVeh={this.selectedVehs} ref={mapDisplay => this._mapRef = mapDisplay} pingData={this.pingData}
                            gfData={this.state.gfData && this.state.gfData.length ? this.state.gfData : null} vehicleStatus={this.vehicleStatus}
                            lastSeenData={this.showFiltData && Object.keys(this.showFiltData).length ? this.showFiltData : this.lastSeenData}
                          />
                          : null
                  }
                </Row>
              </div>
          }
        </div>
      </Col>
    )
  }
}

function getCount(val) { return (<span style={{ color: 'green' }}>{val || '...'}</span>); }
